export default "__VITE_ASSET__CcT$rQvS__"